import React from 'react';
import { useSelector } from 'react-redux';
import {
    MotifIcon,
    MotifButton,
    MotifIconButton
} from '@ey-xd/motif-react';
import {
    actionIcExitToApp24px,
    avIcLibraryBooks24px,
    communicationIcMailOutline24px,
    imageIcTune24px,
    fileIcFileUpload24px
} from '@ey-xd/motif-react/assets/icons';
import Support from '../../assets/images/ic_lifering.svg';
import content from '../../constants/content'
import authorize from '../../providers/authorize';
import './Footer.scss';
import UtilityService from '../../providers/utilityService';
import AdobeEventRegister from '../../app_config/adobeEventRegister';
import EyLogo from '../../assets/images/ey_logo.svg';

const Footer = () => {
    const authStore = useSelector(state => state.authenticationData);
    const configData = useSelector(state => state.generalData.configuration);
    const logoConfig = configData &&
        configData.FooterConfiguration &&
        configData.FooterConfiguration.generalConfig &&
        configData.FooterConfiguration.generalConfig.logo;
    const eyKnowledgeConfig = configData &&
        configData.FooterConfiguration &&
        configData.FooterConfiguration.generalConfig &&
        configData.FooterConfiguration.generalConfig.eyKnowledge && configData.FooterConfiguration.generalConfig.eyKnowledge;
    const footerConfig = configData &&
        configData.FooterConfiguration &&
        configData.FooterConfiguration.footerLinks;
    /**
     * handle logout by clearing the store data and MSAL object.
     *
     */
    const handleLogout = () => {

        UtilityService.adobeCommonScript(AdobeEventRegister.footer.linkClick.eventName, "Logout", AdobeEventRegister.footer.linkClick.componentlinkIdentifier);
        authorize.signOut();
    }

    // handle footer menu click and add entry to adobe analytics
    const handleLinkClick = (menuName) => {
        const menu = menuName.charAt(0).toUpperCase() + menuName.slice(1);
        UtilityService.adobeCommonScript(AdobeEventRegister.footer.linkClick.eventName, menu, AdobeEventRegister.footer.linkClick.componentlinkIdentifier);
    }


    const getIcon = (iconId) => {
        switch (iconId) {
            case 'submitContent':
                return <MotifIcon src={fileIcFileUpload24px} />;
            case 'glossary':
                return <MotifIcon src={avIcLibraryBooks24px} />;
            case 'feedback':
                return <MotifIcon src={communicationIcMailOutline24px} />;
            case 'support':
                return <span className="motif-icon">
                    <img src={Support} alt="help" />
                </span>;
            case 'settings':
                return <MotifIcon className="settings" src={imageIcTune24px} />;
            default:
                return <div />;
        }

    }

    return (
        <>
            {authStore.isAuthenticated ? (
                <div className="footer-container ">
                    <div className="footer-content motif-container" >
                        <div className="action-container">
                            <div className="logo-container">
                                <a target={logoConfig && logoConfig.openInNewTab ? "blank" : ""}
                                    href={logoConfig && logoConfig.url}
                                    onClick={() => handleLinkClick("Discover Home Page")}>
                                    <MotifIconButton type="button" title="EY DISCOVER" aria-label="EY DISCOVER">
                                        <img src={EyLogo} alt="EY" title="EY DISCOVER" />
                                    </MotifIconButton>
                                </a>
                                <div className="logo-text">
                                    <a target={logoConfig && logoConfig.openInNewTab ? "blank" : ""
                                    }
                                        href={logoConfig && logoConfig.url}
                                        onClick={() => handleLinkClick("Discover Home Page")} ><p className="main-label">{content.footer.primaryLabel}</p></a>
                                    <span className="sub-label-container">
                                        <a target={logoConfig && logoConfig.openInNewTab ? "blank" : ""
                                        }
                                            href={logoConfig && logoConfig.url}
                                            onClick={() => handleLinkClick("Discover Home Page")} >  <span className="sub-label-one">{content.footer.secondaryLabel1}</span></a>
                                        {eyKnowledgeConfig && eyKnowledgeConfig.url && eyKnowledgeConfig.url.length > 0 ?
                                            <a onClick={() => handleLinkClick("Discover Home Page")} href={eyKnowledgeConfig && eyKnowledgeConfig.url}

                                                target={eyKnowledgeConfig && eyKnowledgeConfig.openInNewTab ? "blank" : ""
                                                } className="sub-label-two" style={{display:"none"}}>{content.footer.secondaryLabel2} </a> : null}
                                    </span>
                                </div>
                            </div>
                            <div className="button-container">
                                {footerConfig && footerConfig.length > 0 && footerConfig.map((footerItem) => (
                                    footerItem.url &&
                                        footerItem.url.length > 0 ?
                                        <a key={footerItem.id} rel="noreferrer" target={footerItem.openInNewTab ? "_blank" : ""} href={footerItem.url} onClick={() => handleLinkClick(footerItem.title)}>
                                            <MotifButton type="button" aria-label={footerItem.title}
                                                title={footerItem && footerItem.title && footerItem.title.toUpperCase()} >
                                                {getIcon(footerItem.id)}
                                                {footerItem.title}
                                            </MotifButton>
                                        </a>
                                        : null

                                )

                                )}
                                <MotifButton type="button" aria-label={content.footer.logOut} title={content.footer.logOut}
                                    onClick={handleLogout}>
                                    <MotifIcon src={actionIcExitToApp24px} />
                                    {content.footer.logOut}
                                </MotifButton>
                            </div>
                        </div>
                        <div className="text-container" dangerouslySetInnerHTML={{
                            __html:
                                configData && configData.FooterConfiguration &&
                                configData.FooterConfiguration.generalConfig &&
                                configData.FooterConfiguration.generalConfig.footerText
                        }} />

                    </div>
                </div>
            ) : null
            }
        </>
    );
};

export default Footer;